import React from 'react';
import AdSense from '../AdSense';

const TopBannerAd: React.FC = () => {
  return (
    <div className="bg-blue-50/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-blue-200 dark:border-gray-800">
      {/* Limitar altura del banner para que sea discreto */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center" style={{ maxHeight: '90px', minHeight: '50px', overflow: 'hidden' }}>
        <AdSense
          slot="7948375761"
          format="horizontal"
          responsive={false}
          style={{ 
            display: 'block',
            maxHeight: '90px',
            maxWidth: '728px',
            width: '100%'
          }}
        />
      </div>
    </div>
  );
};

export default TopBannerAd;
